// Messages for operator/settings/ApiKeys (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.api_keys.head': 'API keys — Operator',
  'operator.api_keys.title': 'API keys',
  'operator.api_keys.desc': 'Scoped keys for the public REST API.',
  'operator.api_keys.new_key': 'New API key',
  'operator.api_keys.token_title': 'Your new API key',
  'operator.api_keys.token_once': "Copy this token now — it won't be shown again.",
  'operator.api_keys.copy': 'Copy',
  'operator.api_keys.copied': 'Copied',
  'operator.api_keys.name': 'Name',
  'operator.api_keys.name_placeholder': 'e.g. ERP integration',
  'operator.api_keys.name_error': 'Name {error}',
  'operator.api_keys.scopes_label': 'Scopes',
  'operator.api_keys.scopes_hint': 'Grant only what this key needs.',
  'operator.api_keys.create': 'Create key',
  'operator.api_keys.cancel': 'Cancel',
  'operator.api_keys.prefix': 'Prefix',
  'operator.api_keys.last_used': 'Last used {when}',
  'operator.api_keys.created': 'Created {when}',
  'operator.api_keys.never': 'never',
  'operator.api_keys.no_scopes': 'No scopes',
  'operator.api_keys.status.active': 'Active',
  'operator.api_keys.status.revoked': 'Revoked',
  'operator.api_keys.revoke': 'Revoke',
  'operator.api_keys.confirm_revoke':
    'Revoke this key? Apps using it will stop working immediately.',
  'operator.api_keys.empty': 'No API keys yet.',
  'operator.api_keys.empty_hint': 'Create a key to start calling the public REST API.',
  'operator.api_keys.logs.title': 'Recent requests',
  'operator.api_keys.logs.view_all': 'View all requests',
  'operator.api_keys.logs.empty': 'No requests yet.',
  'operator.api_keys.col.method': 'Method',
  'operator.api_keys.col.path': 'Path',
  'operator.api_keys.col.status': 'Status',
  'operator.api_keys.col.ip': 'IP',
  'operator.api_keys.col.when': 'When',
  'operator.api_keys.detail.head': '{name} — API key',
  'operator.api_keys.detail.back': 'Back to API keys',
  'operator.api_keys.detail.requests': 'Requests ({total})',
  'operator.api_keys.detail.showing': 'Showing {first}–{last} of {total}',
  'operator.api_keys.detail.page': 'Page {page} of {pages}',
  'operator.api_keys.detail.prev': 'Previous',
  'operator.api_keys.detail.next': 'Next',
}

export const zhTW = {
  'operator.api_keys.head': 'API 金鑰 — 操作員',
  'operator.api_keys.title': 'API 金鑰',
  'operator.api_keys.desc': '用於公開 REST API 的範圍化金鑰。',
  'operator.api_keys.new_key': '新增 API 金鑰',
  'operator.api_keys.token_title': '您的新 API 金鑰',
  'operator.api_keys.token_once': '請立即複製此權杖 — 之後將不會再顯示。',
  'operator.api_keys.copy': '複製',
  'operator.api_keys.copied': '已複製',
  'operator.api_keys.name': '名稱',
  'operator.api_keys.name_placeholder': '例如：ERP 整合',
  'operator.api_keys.name_error': '名稱{error}',
  'operator.api_keys.scopes_label': '範圍',
  'operator.api_keys.scopes_hint': '僅授予此金鑰所需的範圍。',
  'operator.api_keys.create': '建立金鑰',
  'operator.api_keys.cancel': '取消',
  'operator.api_keys.prefix': '前綴',
  'operator.api_keys.last_used': '最後使用 {when}',
  'operator.api_keys.created': '建立於 {when}',
  'operator.api_keys.never': '從未',
  'operator.api_keys.no_scopes': '無範圍',
  'operator.api_keys.status.active': '啟用中',
  'operator.api_keys.status.revoked': '已撤銷',
  'operator.api_keys.revoke': '撤銷',
  'operator.api_keys.confirm_revoke': '要撤銷此金鑰嗎？使用它的應用程式將立即停止運作。',
  'operator.api_keys.empty': '尚無 API 金鑰。',
  'operator.api_keys.empty_hint': '建立金鑰以開始呼叫公開 REST API。',
  'operator.api_keys.logs.title': '近期請求',
  'operator.api_keys.logs.view_all': '查看所有請求',
  'operator.api_keys.logs.empty': '尚無請求。',
  'operator.api_keys.col.method': '方法',
  'operator.api_keys.col.path': '路徑',
  'operator.api_keys.col.status': '狀態',
  'operator.api_keys.col.ip': 'IP',
  'operator.api_keys.col.when': '時間',
  'operator.api_keys.detail.head': '{name} — API 金鑰',
  'operator.api_keys.detail.back': '返回 API 金鑰',
  'operator.api_keys.detail.requests': '請求（{total}）',
  'operator.api_keys.detail.showing': '顯示第 {first}–{last} 筆，共 {total} 筆',
  'operator.api_keys.detail.page': '第 {page} 頁，共 {pages} 頁',
  'operator.api_keys.detail.prev': '上一頁',
  'operator.api_keys.detail.next': '下一頁',
}
